"use strict";

var debug = require("debug")("knack.formatter.formatters.name");

/**
 * @alias "formatters.name"
 * @param {Object} value
 * @param {String} value.title
 * @param {String} value.first
 * @param {String} value.middle
 * @param {String} value.last
 * @param {Object} [format]
 * @param {String} [format.format] How to format the name
 * @return {String}
 */
var nameFormatter = function nameFormatter(value, format) {
  var output = "";
  if (!value) {
    return "";
  }
  if (!value.first && !value.last) {
    return "";
  }
  if (!format) {
    format = {
      format: "First Last"
    };
  }
  switch (format.format) {
    case "Title First Last":
      if (value.title && value.title !== "'None") {
        output += "".concat(value.title, " ");
      }
      output += "".concat(value.first, " ").concat(value.last);
      break;
    case "First Middle Last":
      if (value.first) {
        output += "".concat(value.first, " ");
      }
      if (value.middle) {
        output += "".concat(value.middle, " ");
      }
      output += value.last;
      break;
    case "Last, First":
      output = "".concat(value.last, ", ").concat(value.first);
      break;
    case "Last, First Middle":
      output = "".concat(value.last, ", ").concat(value.first);
      if (value.middle) {
        output += " ".concat(value.middle);
      }
      break;
    case "First Last":
    default:
      output = "".concat(value.first, " ").concat(value.last);
      break;
  }
  return output;
};
module.exports = nameFormatter;